import { Checkup } from "../models/checkup";

export const CheckupDto = (data: any): Checkup => {
  if (!data) {
    return {
      id: "",
      name: "",
      description: "",
      odometer: 0,
      hourmeter: null,
      services: []
    };
  }

  const checkupIdentification = data?.range?.start === 0 ? 
    'Revisão de entrega' : 
    !data?.range?.start ?
      '-' : (data?.range?.start?.toLocaleString('pt-BR') + ' Km');

  return {
    id: data.id ?? '',
    type: data.type,
    name: data.checkupType || checkupIdentification,
    description: checkupIdentification,
    odometer: data.range?.start,
    hourmeter: null,
    services: data.checkupType?.services ?? [],
    aditionalServices: (data.compls ?? []).map((compl: any) => ({
      id: compl.id,
      name: compl.name,
      price: compl.price ?? 0,
    })),
    parts: (data.parts ?? []).map((p: any) => ({
      code: p.code ?? "",
      description: p.description ?? "",
      qtd: p.qtd ?? 0,
      isCovered: p.isCovered === true,
      notCoveredReason: p.notCoveredReason ?? undefined,
    })),
  };
};
